const AvatarWithName = ({name = ''}) => {
  return (
    <div className="flex gap-2">
      <div className="m-auto ml-0 mr-0 h-7 w-7 rounded-full bg-gray-400" />
      <div className="m-auto ml-0 mr-0">{name}</div>
    </div>
  );
};

export default AvatarWithName;
